import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import ImageCarousel from '../UI/ImageCarousel';
import Navbar from '../UI/Navbar';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();
  
  const goToCreatePage = () => {
    navigate('/create');
  };

  // Popular styles to showcase
  const popularStyles = [
    { name: 'Starter Pack', file: 'aivatar_Starter_Pack.webp' },
    { name: 'Cyberpunk', file: 'aivatar_Cyberpunk.webp' },
    { name: 'Synthwave', file: 'aivatar_Synthwave.webp' },
    { name: 'Pixel Art', file: 'aivatar_Pixel_Art.webp' },
    { name: 'Dark Fantasy', file: 'aivatar_Dark_Fantasy.webp' },
    { name: 'Disney Pixar', file: 'aivatar_Disney_Pixar.webp' },
  ];

  // All styles data - hidden initially but accessible via "Try All Styles" button
  const allStyles = [
    { name: 'Anime', file: 'aivatar_Anime.webp' },
    { name: 'Cyberpunk', file: 'aivatar_Cyberpunk.webp' },
    { name: 'Oil Painting', file: 'aivatar_Oil_Painting.webp' },
    { name: 'Pixel Art', file: 'aivatar_Pixel_Art.webp' },
    { name: 'Studio Ghibli', file: 'aivatar_Studio_Ghibli.webp' },
    { name: 'Pop Art', file: 'aivatar_Pop_Art.webp' },
    { name: 'Synthwave', file: 'aivatar_Synthwave.webp' },
    { name: 'Digital Watercolor', file: 'aivatar_Digital_Watercolor.webp' },
    { name: 'Lo-fi Illustration', file: 'aivatar_Lo-fi_Illustration.webp' },
    { name: 'Urban Sketch', file: 'aivatar_Urban_Sketch.webp' },
    { name: 'Retro Comic', file: 'aivatar_Retro_Comic.webp' },
    { name: 'Y2K Chrome', file: 'aivatar_Y2K_Chrome.webp' },
    { name: 'AI Surrealism', file: 'aivatar_Ai_Surrealism.webp' },
    { name: 'Arcane Painterly', file: 'aivatar_Arcane_Painterly.webp' },
    { name: 'Chibi', file: 'aivatar_Chibi.webp' },
    { name: 'Cottagecore', file: 'aivatar_Cottagecore.webp' },
    { name: 'Dark Fantasy', file: 'aivatar_Dark_Fantasy.webp' },
    { name: 'Disney Pixar', file: 'aivatar_Disney_Pixar.webp' },
    { name: 'Goblincore', file: 'aivatar_Goblincore.webp' },
    { name: 'Holo Iridescent', file: 'aivatar_Holo_Iridescent.webp' },
    { name: 'Low Poly', file: 'aivatar_Low_Poly.webp' },
    { name: 'Medieval Knight', file: 'aivatar_Medieval_Knight.webp' },
    { name: 'Mob Wife', file: 'aivatar_Mob_Wife.webp' },
    { name: 'Neo Brutalism', file: 'aivatar_Neo_Brutalism.webp' },
    { name: 'Papercut Layered', file: 'aivatar_Papercut_Layered.webp' },
    { name: 'Solarpunk', file: 'aivatar_Solarpunk.webp' },
    { name: 'Starter Pack', file: 'aivatar_Starter_Pack.webp' },
    { name: 'Steampunk', file: 'aivatar_Steampunk.webp' },
    { name: 'Tech Minimalist', file: 'aivatar_Tech_Minimalist.webp' },
    { name: 'Vaporwave', file: 'aivatar_Vaporwave.webp' },
  ];
  
  return (
    <div className="landing-page">
      <Navbar />
      
      <ImageCarousel />
      
      <main className="landing-page__main-content">
        <div className="landing-page__hero">
          <h1>Your Photos, Reimagined as Art</h1>
          <p className="landing-page__subtitle">Turn yourself into stunning avatars across 30+ artistic styles in just seconds</p>
          
          <div className="cta-container">
            <button onClick={goToCreatePage} className="btn btn-primary">Create Your Avatar Now</button>
          </div>
        </div>
        
        <section className="landing-page__examples-section">
          <div className="container">
            <h2>Stand Out With 30+ Unique Styles</h2>
            <p className="landing-page__examples-subtitle">From anime to oil paintings — find the perfect look that's uniquely you</p>
            
            <div className="landing-page__reference-photos">
              <div className="landing-page__reference-photo-container">
                <h3>Upload Any Clear Portrait</h3>
                <div className="landing-page__reference-images">
                  <img src={`${process.env.PUBLIC_URL}/images/examples/ChatGPT Image 29 avr. 2025, 11_43_10.png`} alt="Reference Photo 1" className="landing-page__reference-img" />
                  <img src={`${process.env.PUBLIC_URL}/images/examples/ChatGPT Image 29 avr. 2025, 11_43_13.png`} alt="Reference Photo 2" className="landing-page__reference-img" />
                </div>
              </div>
            </div>
            
            <h3 className="landing-page__popular-styles-heading">Most Popular Styles</h3>
            <div className="landing-page__popular-styles-grid">
              {popularStyles.map((style, index) => (
                <div className="landing-page__popular-style-card" key={index}>
                  <img 
                    src={`${process.env.PUBLIC_URL}/images/examples/${style.file}`} 
                    alt={`Style ${style.name}`} 
                    className="landing-page__popular-style-img" 
                  />
                  <h4>{style.name}</h4>
                </div>
              ))}
            </div>
            
            <div className="landing-page__view-more-container">
              <p className="landing-page__more-styles-text">Plus 25+ more styles to discover!</p>
              <button onClick={goToCreatePage} className="btn btn-secondary">Try All Styles</button>
            </div>
          </div>
        </section>
        
        <section className="landing-page__features-section">
          <div className="container">
            <h2>Why AIvatar Crushes the Competition</h2>
            
            <div className="landing-page__features-grid">
              <div className="landing-page__feature-card">
                <div className="landing-page__feature-icon">⚡</div>
                <h3>30-Second Transformation</h3>
                <p>Upload, select, and download your new avatars faster than making coffee</p>
              </div>
              
              <div className="landing-page__feature-card">
                <div className="landing-page__feature-icon">🎨</div>
                <h3>30+ Stunning Art Styles</h3>
                <p>From retro to futuristic — there's a perfect style waiting for your personality</p>
              </div>
              
              <div className="landing-page__feature-card">
                <div className="landing-page__feature-icon">🔒</div>
                <h3>Your Photos, Protected</h3>
                <p>Instant processing and automatic deletion — your privacy is our priority</p>
              </div>
              
              <div className="landing-page__feature-card">
                <div className="landing-page__feature-icon">💫</div>
                <h3>Gallery-Worthy Avatars</h3>
                <p>Our AI delivers professional-quality results you'll be proud to display anywhere</p>
              </div>
              
              <div className="landing-page__feature-card">
                <div className="landing-page__feature-icon">🌐</div>
                <h3>Access Anywhere</h3>
                <p>Your avatar collection follows you across all your devices — always available</p>
              </div>
              
              <div className="landing-page__feature-card">
                <div className="landing-page__feature-icon">🔄</div>
                <h3>Print-Ready Quality</h3>
                <p>High-resolution avatars perfect for social profiles, prints, and merchandise</p>
              </div>
            </div>
          </div>
        </section>
        
        <section className="landing-page__testimonials-section">
          <div className="container">
            <h2>People Are Obsessed With Their AIvatars</h2>
            
            <div className="landing-page__testimonials-grid">
              <div className="landing-page__testimonial-card">
                <p className="landing-page__testimonial-text">"The 'Cyberpunk' style blew my mind! I've already ordered prints for my gaming room. Everyone asks where I got them!"</p>
                <div className="landing-page__testimonial-author">— Sarah K.</div>
              </div>
              
              <div className="landing-page__testimonial-card">
                <p className="landing-page__testimonial-text">"After trying 5 different avatar apps, nothing comes close to AIvatar's quality. My Instagram followers doubled after I changed my profile pic!"</p>
                <div className="landing-page__testimonial-author">— Mark T.</div>
              </div>
              
              <div className="landing-page__testimonial-card">
                <p className="landing-page__testimonial-text">"Created matching avatars for my entire team in 10 minutes. Our Slack channel looks amazing now!"</p>
                <div className="landing-page__testimonial-author">— Julie B.</div>
              </div>
            </div>
          </div>
        </section>
        
        <section className="landing-page__final-cta-section">
          <div className="container text-center">
            <h2>Your Stunning Avatars Are Just 60 Seconds Away</h2>
            <p>Join 50,000+ people who've already transformed their online presence</p>
            <button onClick={goToCreatePage} className="btn btn-primary">Start Creating Now</button>
          </div>
        </section>
      </main>
      
      <footer className="footer">
        <div className="container">
          <p>© 2025 AIvatar. All rights reserved.</p>
          <div className="footer-links">
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <a href="mailto:contact@muware.xyz">Contact Us</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage; 